/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cp_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes — click any swatch and its hex code is copied to your clipboard.`)
};

const es_cp_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí — haz clic en cualquier muestra y su código hexadecimal se copia a tu portapapeles.`)
};

const de_cp_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja — klicke auf ein beliebiges Farbfeld, und dessen Hex-Code wird in die Zwischenablage kopiert.`)
};

const nl_cp_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja — klik op een kleurvlak en de hexcode wordt naar je klembord gekopieerd.`)
};

const fr_cp_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui — cliquez sur n'importe quel échantillon et son code hexadécimal est copié dans votre presse-papiers.`)
};

const it_cp_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì — clicca su qualsiasi campione e il suo codice esadecimale viene copiato negli appunti.`)
};

const pt_br2_cp_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim — clique em qualquer amostra e o código hex é copiado para a sua área de transferência.`)
};

const pt_cp_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim — clique em qualquer amostra e o seu código hex é copiado para a área de transferência.`)
};

const ja_cp_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい — スウォッチをクリックすると16進数コードがクリップボードにコピーされます。`)
};

const zh_cp_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可以——点击任意色块，其十六进制代码即会复制到剪贴板。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cp_faq_a4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cp_faq_a4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cp_faq_a4", locale)
	if (locale === "en") return en_cp_faq_a4(inputs)
	if (locale === "es") return es_cp_faq_a4(inputs)
	if (locale === "de") return de_cp_faq_a4(inputs)
	if (locale === "nl") return nl_cp_faq_a4(inputs)
	if (locale === "fr") return fr_cp_faq_a4(inputs)
	if (locale === "it") return it_cp_faq_a4(inputs)
	if (locale === "pt-BR") return pt_br2_cp_faq_a4(inputs)
	if (locale === "pt") return pt_cp_faq_a4(inputs)
	if (locale === "ja") return ja_cp_faq_a4(inputs)
	return zh_cp_faq_a4(inputs)
};